/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Linked_Projects_Settings_DescriptionInputs */



/**
* | output |
* | --- |
* | "Choose which projects can use this resource. Adding a project lets its chats search and reference this resource's content." |
*
* @param {Linked_Projects_Settings_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const linked_projects_settings_description = /** @type {((inputs?: Linked_Projects_Settings_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Linked_Projects_Settings_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Wähle aus, welche Projekte diese Ressource nutzen können. Ein hinzugefügtes Projekt kann die Inhalte dieser Ressource in seinen Chats durchsuchen und referenzieren.")
	return /** @type {LocalizedString} */ ("Choose which projects can use this resource. Adding a project lets its chats search and reference this resource's content.")
});